// Braces520 (AZ; formerly "by Andrew Rosen") - three offices: Tucson, Oro Valley,
// Sierra Vista. Backend: bondLocations.ts BRACES520_TUCSON / _ORO_VALLEY /
// _SIERRA_VISTA (brandId "braces520", catalog ff4f43ca, Edge loc 3/4/2,
// procedure 907, DB 284). Native booking via ortho2-newpatient backend (WCF intake
// disabled - login not provisioned on DB 284). Bilingual en/es (es enabled 2026-08-03, review T2).
import type { BrandConfig } from "./types";

export const braces520: BrandConfig = {
  slug: "braces520",
  brandId: "braces520",
  brandName: "Braces520",
  logo: "https://edgestorage.ortho2.com/logos/03d632b8-8a09-4ce6-bf1f-2ea4e2cf91c0.png",
  phone: "(520) 290-0500",
  phoneHref: "tel:+15202900500",
  theme: { primary: "#F19934", primaryDark: "#154173" }, // scoured 2026-07-14 braces520.com (orange + navy)
  locales: ["en", "es"],
  locations: {
    BRACES520_TUCSON: {
      id: "BRACES520_TUCSON",
      name: "Tucson",
      addressLines: ["1865 N Kolb Road", "Tucson, AZ 85715"],
      mapsUrl: "https://maps.google.com/?q=1865+N+Kolb+Road+Tucson+AZ+85715",
      timezone: "America/Phoenix",
    },
    BRACES520_ORO_VALLEY: {
      id: "BRACES520_ORO_VALLEY",
      name: "Oro Valley",
      addressLines: ["8070 N Oracle Rd", "Oro Valley, AZ 85704"],
      mapsUrl: "https://maps.google.com/?q=8070+N+Oracle+Rd+Oro+Valley+AZ+85704",
      timezone: "America/Phoenix",
    },
    BRACES520_SIERRA_VISTA: {
      id: "BRACES520_SIERRA_VISTA",
      name: "Sierra Vista",
      addressLines: ["1714 Paseo San Luis", "Sierra Vista, AZ 85635"],
      mapsUrl: "https://maps.google.com/?q=1714+Paseo+San+Luis+Sierra+Vista+AZ+85635",
      timezone: "America/Phoenix",
    },
  },
  locationAliases: {
    TUCSON: "BRACES520_TUCSON",
    ORO_VALLEY: "BRACES520_ORO_VALLEY",
    SIERRA_VISTA: "BRACES520_SIERRA_VISTA",
  },
};
